import React from "react";

const KioskIdleModal = ({ open, countdown, onContinue, onExit }) => {
  if (!open) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={titleStyle}>사용이 감지되지 않았습니다</div>
        <div style={descStyle}>
          <b>{countdown}초</b> 후 처음 화면으로 돌아갑니다.
          <br />
          계속 이용하시려면 화면을 터치해주세요.
        </div>

        <div style={buttonWrapStyle}>
          <button style={secondaryBtnStyle} onClick={onExit}>
            처음으로
          </button>
          <button style={primaryBtnStyle} onClick={onContinue}>
            계속 진행
          </button>
        </div>
      </div>
    </div>
  );
};

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(15, 23, 42, 0.55)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 99999,
};

const modalStyle = {
  width: "min(560px, 92vw)",
  background: "#fff",
  borderRadius: "28px",
  padding: "32px",
  boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
  textAlign: "center",
};

const titleStyle = {
  fontSize: "28px",
  fontWeight: 800,
  marginBottom: "14px",
};

const descStyle = {
  fontSize: "18px",
  lineHeight: 1.6,
  color: "#334155",
};

const buttonWrapStyle = {
  marginTop: "24px",
  display: "flex",
  gap: "12px",
  justifyContent: "center",
};

const primaryBtnStyle = {
  minWidth: "160px",
  height: "56px",
  border: "none",
  borderRadius: "16px",
  fontSize: "18px",
  fontWeight: 700,
  cursor: "pointer",
};

const secondaryBtnStyle = {
  minWidth: "160px",
  height: "56px",
  borderRadius: "16px",
  fontSize: "18px",
  fontWeight: 700,
  background: "#f1f5f9",
  border: "none",
  cursor: "pointer",
};

export default KioskIdleModal;